import React from 'react';
import { Button, Col, Icon, Input, Popconfirm, Radio, Row, Table, Tooltip } from 'antd';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { copyArr, Format, uuid, funStrCheck, getType } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { addCtnCommonAttribute } from "./SgiCtnComm";
import { SgiEventHandler } from './SgiEventHandler';
import SgiTableEditorCell from './SgiTableEditorCell';
import { sgiTableBaseFun } from './SgiTableBaseFun';
import { Resizable } from 'react-resizable';
import { convertModuleByGuid } from './SgiCompComm';
import SgiTableCommon from './SgiTableCommon';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
// import '../node_modules/react-resizable/css/styles.css';

const RadioGroup = Radio.Group;

const antd_column_prop_keys = [
    "align",
    "ellipsis",
    "className",
    "colSpan",
    "dataIndex",
    "defaultFilteredValue",
    "defaultSortOrder",
    "filterDropdown",
    "filterDropdownVisible",
    "filtered",
    "filteredValue",
    "filterIcon",
    "filterMultiple",
    "filters",
    "fixed",
    "key",
    "render",
    "sorter",
    "sortOrder",
    "sortDirections",
    "title",
    "width",
    "onCell",
    "onFilter",
    "onFilterDropdownVisibleChange",
    "onHeaderCell"
];

const ResizeableTitle = (props) => {
    const { onResize, width, isLast, ...restProps } = props;

    if (isLast) {
        return <th {...restProps} />;
    }

    return (
        <Resizable width={parseInt(width)} height={0} onResize={onResize}>
            <th {...restProps} />
        </Resizable>
    );
};
const components = {
    header: { cell: ResizeableTitle },
};

class SgiTV extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showPageFlg: true,//是否显示翻页信息
            pagination: {},//分页信息
            batchInfo: {},//分批查询信息
            size: 'default',
            expandedRowRender: [], //展开列
            footer: {},
            rowSelection: null, //选择属性
            columns: [], //列信息
            expandedColumns: [], //列信息
            tableProps: { style: {} }, //表格属性
            dataSource: [], //显示数据==>原始数据
            store: [], //表格的显示数据(原始数据筛选后)
            insName: '',//绑定实例名
            loading: false, //刷新属性 //是否加载中
            // selectedRowKeys: [] //选择的列信息 //放入到了rowSelection中
            functions: {},
            selectedRows: [], //已选择/勾选的行对象数组
            selFlg: false,
            selValues: {},//筛选对象
            contain: true,//筛选选择(包含/不包含)，默认包含
            cstmClmnFlg: false,//自定义表格列描述
            resizable: false,//列头可伸缩
        };
    }

    /**
     * 根据描述创建表格
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    table_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }

        // 获取绑定tv参数
        var ClmDes = this.getClmDes(moduleDesc);
        // 从对象工厂中获取表格绑定数据（创建表格store 搜索条、翻页控件需要使用该信息，所以先创建）
        var tableStore = this.getTBData(moduleDesc, objFct);
        this.state.dataSource = tableStore;
        this.state.insName = getConstByKey(this, moduleDesc.insName);//绑定实例名
        // 创建TV表头
        var clms = this.crtClmHead(moduleDesc, ClmDes, objFct, type);
        this.state.columns = clms ? clms : [];

        // 添加表格列,拖拽页面自定义的表格列
        this.crtClmHeadDnd(moduleDesc, moduleDesc.dnd_columns, this.state.columns, this.state.expandedColumns, objFct, type);

        // 创建this.state.pagination分页信息
        this.crtPgeBbar(moduleDesc, tableStore, objFct);
        // 转换公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.tableProps);
        // 转换表格属性
        this.AddTBAttribute(moduleDesc, this.state.tableProps, type);
        // 添加表格的选择模式
        this.crtTblSltModel(moduleDesc);
        // 绑定事件
        this.bindEvent(moduleDesc, this.state.tableProps, this.state.rowSelection, this.state.functions, type);
    }

    /**
     * 表格基本属性
     * @param {*} moduleDesc
     * @param {*} tableColumn
     */
    AddTBAttribute(moduleDesc, tableProps, type) {

        if (moduleDesc.isHeaders) tableProps.showHeader = !moduleDesc.isHeaders; //隐藏列头
        if (moduleDesc.isTbSpt) tableProps.bordered = moduleDesc.isTbSpt; //列线

        this.state.selFlg = !!moduleDesc.isSel; //是否筛选
        this.state.showPageFlg = (moduleDesc.isPage === false) ? false : true; //是否显示翻页器,默认显示

        // 表格大小
        tableProps.size = moduleDesc.size || "small";

        // 初始loading
        this.state.loading = (type === "dnd") ? false : (!!moduleDesc.loading);

        // 横向滚动
        if (!tableProps.scroll) tableProps.scroll = {};
        if (moduleDesc.scrollX) tableProps.scroll.x = moduleDesc.scrollX;
        else delete tableProps.scroll;

        // 列可伸缩
        this.state.resizable = !!moduleDesc.resizable;

        tableProps.tableLayout = moduleDesc.tbLayout;
    }

    /**
     * 创建表格 列头信息
     * @param {*} moduleDesc
     * @param {*} ClmDes
     * @param {*} objFct
     * @param {*} type
     */
    crtClmHead(moduleDesc, ClmDes, objFct, type) {
        //wangz追加 如果表格配置信息错误  自定义表头
        if (!ClmDes) {
            return;
        }
        let tableColumns = ClmDes.tvTitles;
        let cldSet = ClmDes.cldSet;
        if (tableColumns && tableColumns.length > 0) {
            // 存在tvTitles
            if (cldSet && cldSet.length > 0) {
                // 同步描述
                let allClds = {};
                cldSet.forEach(cld => {
                    let key = cld.sc || cld.c;
                    if (key) allClds[key] = cld;
                });
                itemForEach(tableColumns, (item) => {
                    let key = item.sc || item.c;
                    let cld = allClds[key];
                    if (cld) Object.assign(item, cld);
                });
            }
            function itemForEach(items = [], foreach) {
                if (!foreach || typeof foreach !== "function") return;
                items.forEach(item => {
                    let cldSet = item.cldSet;
                    if (cldSet && cldSet.length > 0) itemForEach(cldSet, foreach);
                    else if (item.sc || item.c) foreach(item);
                });
            }
        } else {
            // 不存在tvTitles
            tableColumns = cldSet || [];
        }
        // var tableColumns = ClmDes.tvTitles || ClmDes.cldSet;
        var alwEdit = moduleDesc.isEd;
        var clm = this.crtTblClm(alwEdit, tableColumns, getConstByKey(this, moduleDesc.insName), objFct, type, moduleDesc);
        return clm;
    }

    /**
     * 获取表格 列头信息，如果列头是根树，则迭代遍历
     * 表格头数据
     */
    crtTblClm(alwEdit, tblClms = [], bdInst, objFct, type, moduleDesc) {
        let clms = [];
        tblClms.forEach(item => {
            let clmDes = { ...item, ...item.ctlInfo };
            if (!alwEdit && !item.isEd) clmDes.isLabel = true;
            let text = Resource.getTRByPrm(clmDes).te;//clmDes.te;
            delete clmDes.ctlW;
            // 优先--用户自定义渲染组件
            let cstmRender = clmDes.cstmRender;
            let $cstmRender;
            if (funStrCheck(cstmRender)) {
                try {
                    $cstmRender = new Function("text", "record", "index", "objFct", "pagination", cstmRender);
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
            }
            // 转换antd的列属性
            let antd_props = {};
            antd_column_prop_keys.forEach(key => {
                if (clmDes[key]) antd_props[key] = clmDes[key];
            });
            let clm = {
                ...antd_props,
                title: text,
                width: clmDes.cluW || undefined,
                dataIndex: clmDes.c,
                align: clmDes.align,
                render: $cstmRender
                    ? (text, record, index) => $cstmRender(text, record, index, objFct, this.state.pagination)
                    : (text, record, index) => convertModuleByGuid(this, clmDes, record, objFct, type, { noFI: true })
            };
            if (clmDes.cldSet && clmDes.cldSet.length > 0) {
                clm.children = this.crtTblClm(alwEdit, clmDes.cldSet, bdInst, objFct, type) || [];
            }
            // 排序
            if (clmDes.isSt || (moduleDesc.allSt && (!clmDes.cldSet || clmDes.cldSet.length === 0))) {
                try {
                    if (this.state.batchInfo.batchFun) {
                        // 分批
                        element.sorter = true;
                    } else {
                        // 不分批
                        let key = clm.dataIndex;
                        clm.sorter = (a, b) => getType(a[key]) === "string" ? a[key].localeCompare(b[key], 'zh-CN') : (a[key] - b[key]);
                    }
                } catch (error) {
                    sgiLogger.error("添加排序函数失败");
                    sgiLogger.eventErr(error);
                }
            }
            // if (clmDes.isSt) {//该列是否可排序
            //     clm.sorter = (a, b) => {
            //         return a.name.length - b.name.length;
            //     }
            // }
            clms.push(clm);
        });
        return clms;
    }

    /**
     * 获取表格列描述信息
     * @param {描述信息} moduleDesc
     */
    getClmDes(moduleDesc) {
        //是否绑定表头了，绑定了继续
        let dsdDesc = moduleDesc.dsdDesc;
        if (dsdDesc) {
            return dsdDesc;
        } else {
            var guid = moduleDesc.bdTvId;
            if (!guid) return;
            //取得表头guid
            var ClmDes = PrmFactory.getPrm(guid);
            return ClmDes;
        }
    }

    refreshByBdTv(bdTv) {
        if (!bdTv) return;
        this.setState({ refreshFlg: true, bdTv: bdTv });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性 初始化属性到this.state
            this.table_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        if (this.state.selFlg) this.onSel();//筛选
        else this.state.store = this.state.dataSource;//不筛选

        const { cstmClmnFlg, cstmClmn, store, resizable } = this.state;

        let columns = this.state.columns;

        if (this.state.refreshFlg) {
            columns = this.state.columns = [];
            let bdTv = this.state.bdTv;
            if (bdTv) {
                if (typeof bdTv === "string") {
                    //暂时先不处理
                    let tvs = bdTv.split(",");
                    tvs.forEach((item, index) => {
                        let tvJson = PrmFactory.getPrm(item);
                        let clms = this.crtClmHead(moduleDesc, tvJson, objFct, type);
                        columns.push(...clms);
                    })
                } else {
                    let cldSet = bdTv.cldSet;
                    if (cldSet && cldSet.length > 0) {
                        let clms = this.crtClmHead(moduleDesc, bdTv, objFct, type);
                        columns.push(...clms);
                    }
                }
            }
            this.state.refreshFlg = false;
        }

        // 可伸缩列
        if (resizable) {
            this.state.tableProps.components = components;
            columns = this.state.columns.map((col, index, arr) => ({
                ...col,
                onHeaderCell: column => ({
                    width: column.width,
                    onResize: this.handleResize(index),
                    isLast: (index === arr.length - 1)
                }),
            }));
        }

        return (
            <div>
                <div style={{ margin: 5, width: "70%", minWidth: 400, maxWidth: 800, display: (this.state.selFlg ? undefined : "none") }} >
                    {/* <Col span={10} style={{ margin: "0px 5px 0px 5px" }}> */}
                    <Row >
                        <Col span={14}>
                            <Input addonBefore="筛选条件" value={this.state.selValues.mat} onChange={this.selOnChange.bind(this, 'mat')} />
                        </Col>
                        <Col span={10}>
                            <RadioGroup style={{ marginTop: 3, marginLeft: 10 }} value={this.state.contain} onChange={this.containOnChange.bind(this)}>
                                <Radio value={true} style={{ marginRight: 0 }}>包含</Radio>
                                <Radio value={false}>排除</Radio>
                            </RadioGroup>
                        </Col>
                    </Row>
                    {/* </Col> */}
                </div>
                <Table className="sgiTable" {...this.state.tableProps}
                    rowKey={"_key"}
                    loading={this.state.loading}
                    pagination={this.state.showPageFlg ? this.state.pagination : false}
                    rowSelection={this.state.rowSelection}
                    columns={columns}
                    dataSource={this.state.store}
                    onChange={this.tableOnChange.bind(this)}
                    expandedRowRender={this.state.expandedColumns.length > 0 ? this.expandedRowRender.bind(this) : undefined} />
            </div>
        );
    }
}
//给类添加公共方法
Object.assign(SgiTV.prototype, sgiTableBaseFun);
Object.assign(SgiTV.prototype, SgiTableCommon);
export { SgiTV };
export default SgiTV;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTV.js